export type ProviderAccountModel = {
  account_locked?: boolean,
  agency_id: number,
  cache_key: number,
  enable_account_lock: boolean,
  id: number,
  notes: string,
  provider_id: number,
  terms: string,
}

export type ProviderAccountRequestOptions = {}

const state = {
  id: null,
  agency_id: null,
  enable_account_lock: false,
  notes: '',
  provider_id: null,
  terms: '',
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'provider_id' },
]

export default state
